<div class="bg-gray-100 flex items-center justify-center h-screen mt-16">
    <div class="text-center">
      <h1 class="text-6xl font-bold text-gray-800">404</h1>
      <p class="text-2xl text-gray-600 mt-4">Página no encontrada</p>
      <a (click)="goBack()"  class="mt-6 inline-block px-6 py-3 text-white bg-secondary rounded-lg hover:bg-primary cursor-pointer">
        Regresar
      </a>
    </div>
  </div>
  